/* eslint-disable @typescript-eslint/no-explicit-any */
import { Container } from 'react-bootstrap'
import contactRectangle from '@assets/img/contact-us-rectangle.webp'
import { useEffect } from 'react'
import { scrollObjFromAnchor, scrollToTargetAdjusted } from 'src/@shared/functions/animations'
import { useRouter } from 'next/router'
import { dehydrate, QueryClient } from 'react-query'
import { getLegalDocs } from 'src/@shared/service/cms-api'

import CustomHead from '@atk/components/head/customHead/customHead'
import Newsletter2 from '@atk/components/newsletter/Newsletter2/Newsletter2'
import Hero from '@atk/components/hero/Hero/Hero'

import useHotspotForm from '@atk/hooks/useHotspotForm'
import FramerMotion from '@atk/hooks/framerMotion'

import ContactForm from '../modules/contact/components/ContactForm/ContactForm'

const initialArgs = { sort: 'position', limit: 0, page: 1 }

export async function getServerSideProps() {
    const queryClient = new QueryClient()
    // prefetch data on the server
    await queryClient.fetchQuery(['legaldocs'], () => getLegalDocs(initialArgs))
    return {
        props: {
            // dehydrate query cache
            dehydratedState: dehydrate(queryClient),
        },
    }
}

export default function Contact() {
    const { loading, show, toggleShow, initHotspotForm } = useHotspotForm({
        region: 'na1',
        portalId: '6073987',
        formId: '3dffe01e-915d-4159-a261-5aa387e33be7',
        target: '#hubspotForm',
    })

    const pageClass = `overflow-hidden contactUsPage`
    const router = useRouter()

    useEffect(() => {
        const timer = setTimeout(() => {
            scrollObjFromAnchor(router.asPath, 60)
            if (router.query.section) {
                scrollToTargetAdjusted(router.query.section.toString(), 60)
            }
            initHotspotForm()
        }, 1500)
        return () => {
            clearTimeout(timer)
        }
    }, [])

    return (
        <>
            <CustomHead
                title="Contact Us & Get Started With Blockchain | Casper Labs"
                description="Connect with Casper Labs and reach out to our team. Discover how our blockchain ecosystems and expertise can transform your business & create new value."
            >
                <link rel="preload" href={contactRectangle.src} as="image" />
            </CustomHead>
            <FramerMotion animation="fadeIn">
                <div className={pageClass}>
                    <main>
                        <Hero
                            isHeader
                            customClass="contactHero pt-0 pb-0"
                            col1={6}
                            col2={6}
                            halfTitle="Contact us"
                            title="Let's Move Forward, Together"
                            desc="Starting the journey towards revenue transformation starts with a single step. Let's talk."
                            bgImage={contactRectangle.src}
                        ></Hero>
                        <Container>
                            <div id="contactForm">
                                <FramerMotion>
                                    <ContactForm
                                        loading={loading ?? true}
                                        show={show ?? false}
                                        toggleShow={toggleShow}
                                    />
                                </FramerMotion>
                            </div>
                        </Container>
                        <Newsletter2 col1={5} col2={7} title="Sign up for our newsletter!" />
                    </main>
                </div>
            </FramerMotion>
        </>
    )
}
